import React, { Component } from "react";
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import { inject, observer } from "mobx-react";
import ReactGA from 'react-ga';

import { TransitionGroup, CSSTransition } from "react-transition-group";
import _ from "lodash";
import Home from "../components/Home";
import Work from "../components/Work";
import Header from "../components/Header";
import Loader from "../elements/Loader";

@inject("projects")
@observer
class User extends Component {
  constructor(props) {
    super(props);
    this.state = {
      whiteLogo: true,
      projects: null,
      isLoaded: false
    };
  }
  componentDidMount() {
    ReactGA.initialize('UA-36497395-1');
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  handleChangeLogoColor(white) {
    this.setState({ whiteLogo: white });
  }
  getWork(slug) {
    const { projects } = this.props.projects;

    return _.find(projects, { slug: slug });
  }
  getWorkIndex(slug) {
    const { projects } = this.props.projects;

    return _.findIndex(projects, { slug: slug });
  }
  render() {
    const { projects, isLoaded } = this.props.projects;
    const { whiteLogo } = this.state;

    if (!isLoaded) {
      return <Loader />;
    }
    return (
      <Router basename={"/"}>
        <Route
          render={({ location }) => (
            <TransitionGroup>
              <CSSTransition key={location.pathname} classNames="fade" timeout={1000}>
                <div>
                  <Header
                    projects={projects}
                    white={location.pathname !== "/" && whiteLogo}
                  />

                  <Switch location={location}>
                    <Route
                      exact
                      path={`/`}
                      render={() => <Home projects={projects} />}
                    />
                    <Route
                      exact
                      path={`/works/:workId`}
                      render={({ match }) => {
                        return (
                          <Work
                            onChangeLogoToWhite={white => this.handleChangeLogoColor(white)}
                            workId={match.params.workId}
                            ga={ReactGA}
                            workIndex={this.getWorkIndex(match.params.workId)}
                            work={this.getWork(match.params.workId)}
                          />)
                      }}
                    />
                  </Switch>
                </div>
              </CSSTransition>
            </TransitionGroup>
          )}
        />
      </Router>
    );
  }
}

export default User;



// WEBPACK FOOTER //
// ./src/roleRouters/User.js